export class CssAttributes {
  static readonly height = 'height';
  static readonly top = 'top';
  static readonly left = 'left';
  static readonly width = 'width';
  static readonly zIndex = 'z-index';
  static readonly right = 'right';
  static readonly transform = 'transform';
  static readonly position = 'position';
}
